import { useTranslation } from 'react-i18next';
import { siteConfig } from '../siteConfig';
import { Divider } from '../components/Divider';
import './DressCode.css';

/* Paleta z inspiračního snímku: rezavá, hořčicová, smaragdová, olivová,
   petrolejová, safírová, švestková, fuchsiová, pudrově růžová. */
const PALETTE = [
  '#C05A2B', // rezavá / burnt orange
  '#D99A1C', // hořčicová / marigold
  '#1E6E4E', // smaragdová / emerald
  '#6E7A34', // olivová / olive
  '#1C6E82', // petrolejová / teal
  '#274B86', // safírová / sapphire
  '#5E3A78', // švestková / plum
  '#A81F63', // fuchsiová / magenta
  '#B07178', // pudrově růžová / dusty rose
];

export function DressCode() {
  const { t } = useTranslation();
  return (
    <section id={siteConfig.sections.dressCode.anchor} className="section dress">
      <Divider />
      <div className="section-header">
        <div className="section-kicker">{t('dress.kicker')}</div>
        <h2 className="section-title">{t('dress.title')}</h2>
      </div>

      <p className="dress__formality">{t('dress.formality')}</p>

      <figure className="dress__moodboard">
        <img
          src="/assets/dresscode/moodboard.webp"
          alt={t('dress.moodboardAlt')}
          loading="lazy"
          width={1400}
          height={1379}
        />
      </figure>

      <div className="dress__swatches" aria-hidden="true">
        {PALETTE.map((c) => (
          <span key={c} className="dress__swatch" style={{ background: c }} />
        ))}
      </div>
      <p className="dress__palette-label">{t('dress.colors')}</p>

      <p className="dress__note">{t('dress.note')}</p>
    </section>
  );
}
